/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_SaveInputs */

const vi_einvoice_settings_save = /** @type {(inputs: Einvoice_Settings_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu hoá đơn điện tử`)
};

/**

* @param {Einvoice_Settings_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_save = /** @type {((inputs?: Einvoice_Settings_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_save(inputs)
});